import { Component, TemplateRef, ContentChild, ResourceRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Input } from '@angular/core';

@Component({
  selector: 'risr-resource-wrapper',
  templateUrl: './resource.wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class ResourceWrapperComponent<T> {
  @Input() resource!: ResourceRef<T | undefined>;

  @ContentChild('loadingTemplate') loadingTemplate?: TemplateRef<any>;
  @ContentChild('errorTemplate') errorTemplate?: TemplateRef<any>;
  @ContentChild('emptyTemplate') emptyTemplate?: TemplateRef<any>;
}
